import React, {useState} from 'react'
import {activateAd, createAd, pauseAd} from "../../services/facebook-ads-service";
import {saveSingleAd} from "../../services/facebook-ad-data.service";
import ShowProgressSpinner from "../../../common/ui/show-progress-spinner";

const CreatFacebookAd = ({adSet, adCreative, existingAd, afterCreateOrEditAdAction}) => {
    const [saveInProgress, setSaveInProgress] = useState(false);

    const handleCreateFacebookAd = async () => {
        setSaveInProgress(true);

        const ad: any = {
            name: adCreative?.name + ' - Ad',
            adset_id: adSet?.id,
            creative: {
                creative_id: adCreative?.id
            },
            status: 'PAUSED',
        };

        const createdAd = await createAd(ad);

        ad.adCreativeId = adCreative?.id;
        ad.adId = createdAd?.id;
        ad.id = createdAd?.id;
        ad.adSetId = adSet?.id;
        ad.designId = adSet?.designId;
        ad.campaignId = adSet?.campaign_id;
        await saveSingleAd(ad);

        setSaveInProgress(false);

        afterCreateOrEditAdAction();
    }

    const activateFacebookAd = async () => {
        setSaveInProgress(true);
        console.log('activateFacebookAd', {existingAd});

        existingAd.status = 'ACTIVE';
        await activateAd(existingAd);
        await saveSingleAd(existingAd);

        setSaveInProgress(false);
        afterCreateOrEditAdAction();
    }

    const pauseFacebookAd = async () => {
        setSaveInProgress(true);
        console.log('pauseFacebookAd', {existingAd});

        existingAd.status = 'PAUSED';
        await pauseAd(existingAd);
        await saveSingleAd(existingAd);

        setSaveInProgress(false);
        afterCreateOrEditAdAction();
    }

    return (
        <>
            <div className="flex items-center justify-end mr-2">
                <div className="">
                    <ShowProgressSpinner dataFetchInProgress={saveInProgress}/>
                </div>

                {!existingAd &&
                    <button
                        onClick={handleCreateFacebookAd}
                        className="button-green px-2 py-1">
                        Create Ad
                    </button>
                }

                {existingAd &&
                    <>
                        {existingAd.status === 'PAUSED' &&
                            <button
                                onClick={activateFacebookAd}
                                className="button-sky px-2 py-1">
                                Activate Ad
                            </button>
                        }

                        {existingAd.status === 'ACTIVE' &&
                            <button
                                onClick={pauseFacebookAd}
                                className="button-outline-red px-2 py-1">
                                Pause Ad
                            </button>
                        }
                    </>
                }
            </div>
        </>
    )
}

export default CreatFacebookAd
